// Bridge file to re-export the existing Firebase configuration
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import app from './util/firebase';

// Initialize Firebase compat for older Firebase API usage
if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBrhYVVDw9TwDRsYA61pvU3Be3DWSNZo28",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "chessisfun-66b29.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "chessisfun-66b29",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "chessisfun-66b29.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "745788597509",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:745788597509:web:7a57f394e8f36b855fc36c",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NCFZX4RBKY"
  });
}



export default firebase;
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage(); 